export const errorCodeMapper: Record<
  string,
  { title: string; message?: string }
> = {
  USER_NOT_IN_MATCH: {
    title: 'Not allowed! 🚫',
  },
};
